import React, { useEffect, useState } from 'react'
import PollsPercentageBox from '../VotesPercentageBox'
import styles from '@bt-react/styles'
import { Progress } from 'reactstrap'
import componentStyle from './VotesResults.module.scss'
import { Option, VotesResultsProps } from './../types'
import classNames from 'classnames'

// TODO: Below to be moved/changed?
export const calculatePercentages = (options: Option[]) => {
  const total = options.reduce((acc, option) => acc += (option?.total ?? 0), 0)
  return options.map(option => total ? Math.floor(((option?.total  ?? 0)/ total) * 100) : 0)
}

const VotesResults: React.FC<VotesResultsProps> = ({ question, options }) => {

  const [percentages, setPercentages] = useState<number[]>(calculatePercentages(options))
  useEffect(() => {
    setPercentages(calculatePercentages(options))
  }, [options])

  return (
  <div
    className={ componentStyle['polls-results-container']}
    data-bdd='polls-results-container'>

    <div className={ classNames([componentStyle['qs-text'], styles['font-weight-bold']]) }>
      <div>Q:</div>
      <div className={ componentStyle['question'] }>
        { question }
      </div>
    </div>
    <div className={ componentStyle['polls-results-bar-container']}>
      <ul className={ componentStyle['polls-results-bar-list']}>
        { options.length && options.map((option, index) =>
          <li key={ index }
              className={ `${componentStyle['polls-answers']} ${styles['row']} ${styles['m-0']}`}>
            <div className={`${styles['col-10']} ${styles['p-0']}`}>
              <div className={componentStyle['polls-answer']}>
                {option.value}
              </div>
              <Progress
                value={percentages[index]}
                className={componentStyle['polls-progress']}
                barClassName={componentStyle['polls-main-progress']}
                cssModule={styles}/>
            </div>
            <div className={`${styles['col-2']} ${componentStyle['polls-percentage-box']}`}>
              <PollsPercentageBox percentage={percentages[index]}/>
            </div>
          </li>
        )}
      </ul>
    </div>
  </div>
  )
}

export default VotesResults
